import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_TEMPLATE_BY_ID, GET_TEMPLATE_BY_ID_SUCCESS, GET_TEMPLATE_BY_ID_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getTemplateById({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    delete filteredHeaders['X-Requested-By'];

    const { templateId, entityType } = payload?.data ?? {};

    /* Two ways to name the same template. The campaign wizard has an id from the
     * template dropdown; the data-upload modal only knows the entity type the user
     * picked, and the backend resolves that to the active template for it. Same
     * response shape either way, so both feed this one slice. */
    const url = entityType
      ? `${adminAPIURL}/v1/surge-templates/template-by-entity-type/${entityType}`
      : `${adminAPIURL}/v1/surge-templates/template-by-id/${templateId}`;

    const response = yield call(apiCall, {
      url,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_TEMPLATE_BY_ID_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TEMPLATE_BY_ID_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TEMPLATE_BY_ID_ERROR, payload: error });
  }
}

export function* watchGetTemplateById() {
  yield takeEvery(GET_TEMPLATE_BY_ID, getTemplateById);
}

function* getTemplateByIdSaga() {
  yield all([fork(watchGetTemplateById)]);
}

export default getTemplateByIdSaga;
